import React from "react";

const DynataLogo: React.FC = () => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 597.26 153.7"
  >
    <g
      id="Full_Color_Logo"
      data-name="Full Color Logo"
    >
      <g
        id="Full_Color_Logo-2"
        data-name="Full Color Logo"
      >
        <g>
          <path
            d="M87.41,123.5l-18.9-7.4c-7.2,6.1-16.4,9.5-25.8,10-7.2,0-14.1-2-20.2-5.6-6.9-3.8-12.5-9.5-16.4-16.4C2.01,97.2.01,89.3.01,81.3c-.3-12.8,5.1-24.8,14.8-33.2,13.6-13.3,34.8-14.8,50.1-3.6,1,.8,2.3.5,3.1-.5,0-.3.5-.8.5-1.3V0l18.9,7.4v116.1h0ZM26.01,62.1c-4.6,5.4-7.2,12.3-6.6,19.4,0,9.2,2.8,16.4,8.4,21.5,4.6,4.1,10.5,6.1,16.4,6.1s13.3-2.6,17.6-7.7c4.9-5.6,7.2-12.8,6.6-19.9,0-9.2-2.8-16.4-8.4-21.2-4.6-4.1-10.5-6.1-16.4-5.9-6.9,0-13.3,2.6-17.9,7.7h.3Z"
            fill="#1c355e"
          />
          <path
            d="M118.91,153.7l14.8-34.3-34.3-79.8h20.5l24,57,25.1-57h20.2l-50.6,114.1h-19.7Z"
            fill="#1c355e"
          />
          <path
            d="M202.31,39.6h18.9c0,1.5,1.3,2.8,2.8,2.8s1.3,0,1.5-.5c4.9-3.3,10.7-5.1,16.9-5.1s17.1,2.8,23.5,8.7c7.9,7.2,11.3,16.6,11.3,32.7v45.3h-18.9v-43.7c0-8.2-1-14.3-3.1-18.2-2.6-4.9-7.7-7.4-14.6-7.4-6.6-.3-12.8,2.8-16.4,8.2-2,3.8-3.1,10-3.1,18.9v41.9h-18.9V39.3v.3h.1Z"
            fill="#1c355e"
          />
          <path
            d="M379.71,123.5l-18.9-7.4c-7.2,6.1-16.4,9.5-25.8,10-7.2,0-14.1-2-20.2-5.6-6.9-3.8-12.5-9.5-16.4-16.4-4.1-6.9-6.1-14.8-6.1-22.8-.3-12.8,5.1-24.8,14.6-33.2,7.4-7.2,17.4-11,27.9-11s14.1,2,19.9,5.9c1.8,1,4.3.5,5.4-1.3.3-.5.5-1.3.5-2h18.9v83.9h.3-.1v-.1ZM318.11,62.1c-4.6,5.4-6.9,12.3-6.6,19.4,0,9.2,2.8,16.4,8.4,21.5,4.6,4.1,10.5,6.1,16.4,6.1s13.3-2.6,17.9-7.7c4.6-5.6,7.2-12.8,6.6-19.9,0-9.2-2.8-16.4-8.4-21.2-4.6-4.1-10.5-6.1-16.6-5.9-6.6,0-13.3,2.8-17.9,7.7h.3-.1Z"
            fill="#1c355e"
          />
          <path
            d="M436.01,39.6v16.9h-13.3v40.4c0,7.2,1.5,10,5.6,10s5.9-.8,9-1.5v17.6c-3.8,1-7.7,1.8-11.5,1.8-5.9,0-11.8-2.3-15.9-6.6-4.1-4.6-6.1-11.5-6.1-21.2v-40.4h-9v-16.9h5.4c2,0,3.6-1.5,3.6-3.6h0V3.6l18.9,7.4v28.6h13.3Z"
            fill="#1c355e"
          />
          <path
            d="M533.51,123.42l-18.7-7.32c-7.2,6.1-16.4,9.5-25.8,10-7.2,0-14.1-2-20.2-5.6-6.9-3.8-12.5-9.5-16.4-16.4-4.1-6.9-6.1-14.8-6.1-22.8-.3-12.8,5.1-24.8,14.6-33.2,7.4-7.2,17.4-11,27.9-11s14.1,2,19.9,5.9c1.8,1,4.3.5,5.4-1.3.3-.5.5-1.3.5-2h18.9v83.72M472.31,62.1c-4.6,5.4-6.9,12.3-6.6,19.4,0,9.2,2.8,16.4,8.4,21.5,4.6,4.1,10.5,6.1,16.4,6.1s13.6-2.6,17.9-7.7c4.6-5.6,7.2-12.8,6.6-19.9,0-9.2-2.8-16.4-8.4-21.2-4.6-4.1-10.5-6.1-16.6-5.9-6.9,0-13.3,2.8-17.9,7.7h.3-.1,0Z"
            fill="#1c355e"
          />
          <g>
            <path
              d="M578.62,14.78V4.6h-3.94v-1.02h9.06v1.02h-3.94v10.18h-1.18Z"
              fill="#1c355e"
            />
            <path
              d="M585.63,14.78V3.58h.97l5.12,8.74h-.51l5.07-8.74h.98v11.2h-1.14V5.36h.27l-4.67,8h-.56l-4.7-8h.3v9.42h-1.13Z"
              fill="#1c355e"
            />
          </g>
        </g>
        <polygon
          id="Optimized_path"
          data-name="Optimized path"
          points="569.6 65.99 569.59 3.49 569.54 3.49 569.54 3.48 507.04 3.47 512.56 17.72 555.37 17.71 555.35 60.47 569.6 65.99"
          fill="#fb5043"
        />
      </g>
    </g>
  </svg>
);

export default DynataLogo;
